import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function SessionExpiry() {
  const navigate = useNavigate();

  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);

        if (response.status === 401) {
          const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
          // Don't redirect for auth check endpoints
          if (!url.includes('/auth/me') && !url.includes('/auth/login') && !url.includes('/auth/register')) {
            localStorage.removeItem('token');
            toast.error('Session expired. Please log in again.');
            navigate('/login');
          }
        }

        return response;
      } catch (error) {
        throw error;
      }
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, [navigate]);

  return null;
}
